export default "__VITE_ASSET__DARJuoCD__"